<script setup lang="ts">
const properties = defineProps({
  imageUrl: {
    type: String,
    required: true
  },
  text: {
    type: String,
    required: true
  },
  alt: {
    type: String,
    required: true
  }
})

const heroReady = ref(false)
onMounted(() => {
  heroReady.value = true
})
</script>

<template>
  <div class="header-container" :class="{ 'hero-animate': heroReady }">
    <div class="header-image-container">
      <NuxtImg :src="properties.imageUrl" :alt="properties.alt" class="header-image w-100" />
    </div>
    <div class="header-right-container">
      <span class="header-right-container-text text-h3 font-weight-regular text-md-h1">{{
        properties.text
      }}</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
.header-container {
  display: flex;
  flex-direction: row;
  height: 80vh;
  padding-top: 160px;
}

// eslint-disable-next-line vue-scoped-css/no-unused-selector
.header-container a {
  text-decoration: none;
}

.header-image {
  width: 100%;
  object-fit: cover;
  height: 100%;
}

.header-image-container {
  flex-basis: 100%;
}

.header-right-container {
  width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}

.header-right-container-text {
  // transform: rotate(90deg);
  writing-mode: vertical-rl;
  text-orientation: mixed;
  font-weight: 600;
  color: rgba(var(--v-theme-primary), 1);
}

.header-right-container-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  aspect-ratio: 1/1;
  background-color: rgba(var(--v-theme-primary), 1);
}
</style>
